<template>
  <div
    id="cf-turnstile"
    data-theme="light"
    data-size="flexible"
    :data-action="action"
  />
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  action?: string;
}>();
</script>
